import React from 'react';
import ResponsiveTable, { ResponsiveCell } from '../shared/ResponsiveTable';
import EventActionsMenu from './EventActionsMenu';
import { EventStatusPill } from './EventCard';
import { eventTimeRange, eventTypeLabel, formatEventDate } from './eventConstants';
import { responsePercent, summaryFor } from './eventsBoard';
import { TILE_CLASS } from './eventStyles';
import { DEFAULT_EVENT_WORDS } from './eventWords';

// One real table at every width: on a phone each row becomes a labeled card (the shared responsive-table pattern).
export default function EventsListView({ events, kits, canEdit, onEdit, onCancel, onGuests, onPlan, rsvp = null, words = DEFAULT_EVENT_WORDS }) {
    return (
        <div className={`${TILE_CLASS} ia-tile3d--clip pt-[5px]`} data-testid="events-list">
            <ResponsiveTable className="w-full">
                <thead className="bg-[var(--surface-sunken)]">
                    <tr>
                        {['Date', words.event, 'Type', 'Venue', 'Guests', 'Invited', 'RSVP %', 'Status', ''].map((heading, index) => (
                            <th key={heading || `actions-${index}`} className="px-3 py-3 text-left text-xs font-semibold uppercase tracking-wide whitespace-nowrap text-[var(--ink-muted)]">{heading}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="divide-y divide-[var(--surface-border)]">
                    {events.map((event) => {
                        const canceled = event.engagement?.status === 'canceled';
                        const counts = summaryFor(rsvp, event);
                        const percent = rsvp ? responsePercent(counts) : null;
                        return (
                            <tr key={event.id} data-testid="event-row" className={canceled ? 'opacity-75' : ''}>
                                <ResponsiveCell label="Date" className="px-3 py-3 text-sm text-[var(--ink)]">
                                    <div>{formatEventDate(event.event_date)}</div>
                                    <div className="text-xs text-[var(--ink-muted)]">{eventTimeRange(event)}</div>
                                </ResponsiveCell>
                                <ResponsiveCell label={words.event} className="px-3 py-3 text-sm font-medium text-[var(--ink)]">
                                    <span className={canceled ? 'line-through' : ''}>{event.event_name}</span>
                                </ResponsiveCell>
                                <ResponsiveCell label="Type" className="px-3 py-3 text-sm text-[var(--ink)]">{eventTypeLabel(kits, event.event_type)}</ResponsiveCell>
                                <ResponsiveCell label="Venue" className="px-3 py-3 text-sm text-[var(--ink)]">{event.venue_name || 'Venue to be set'}</ResponsiveCell>
                                <ResponsiveCell label="Guests" className="px-3 py-3 text-sm text-[var(--ink)]">{event.expected_guest_count ?? 'Not set'}</ResponsiveCell>
                                <ResponsiveCell label="Invited" className="px-3 py-3 text-sm text-[var(--ink)]" data-testid="event-row-invited">{rsvp ? counts.invited : '—'}</ResponsiveCell>
                                <ResponsiveCell label="RSVP %" className="px-3 py-3 text-sm text-[var(--ink)]" data-testid="event-row-rsvp">{percent === null ? '—' : `${percent}%`}</ResponsiveCell>
                                <ResponsiveCell label="Status" className="px-3 py-3 text-sm"><EventStatusPill status={event.engagement?.status} /></ResponsiveCell>
                                <ResponsiveCell label="Actions" className="px-3 py-3 text-sm">
                                    <EventActionsMenu event={event} canEdit={canEdit} onEdit={onEdit} onCancel={onCancel} onGuests={onGuests} onPlan={onPlan} words={words} />
                                </ResponsiveCell>
                            </tr>
                        );
                    })}
                </tbody>
            </ResponsiveTable>
        </div>
    );
}
